import { render, staticRenderFns } from "./ProfitExportedBoxes.vue?vue&type=template&id=74aa345c"
import script from "./ProfitExportedBoxes.vue?vue&type=script&lang=js"
export * from "./ProfitExportedBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports